import axios from 'axios';

import { JobsBoardSearchFiltersPayload } from '@hooks/jobsBoard/utils';
import { ApiNames, ApiProxy, ApiRequest, HttpMethod } from '@lib/api/apiProxy';

export class PublicApplicationAPI {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.PublicApplications;
  private static apiSubmit = ApiNames.SubmitApplication;
  private static apiApplications = ApiNames.Applications;

  public static async getPublicApplication(
    ApplicationId: string
  ): Promise<PublicApplication> {
    const endpoint = `${process.env.NEXT_PUBLIC_API_BASE_PATH}/cast_applications/applications/public/${ApplicationId}`;
    try {
      const response = await axios.get(endpoint);
      const data: PublicApplication = response.data;
      return data;
    } catch (error) {
      // Handle errors here
      console.error(error);
      throw error; // Propagate the error if needed
    }
  }

  public static SubmitApplication(
    data: PostSubmitApplicationRequest
  ): Promise<SumbitApplicationResponse> {
    return this.apiProxy.execute(
      new ApiRequest(this.apiSubmit, `/application`, HttpMethod.POST, data)
    );
  }

  public static getJobsBoardPostsPublic(
    jobsBoardSearchFilters: JobsBoardSearchFiltersPayload,
    publicViewCountry: ProductionCountry
  ): Promise<JobsBoardApplication[]> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/public/searchJobsBoard`,
        HttpMethod.POST,
        {
          filters: jobsBoardSearchFilters,
          public_country: publicViewCountry,
        },
        {},
        {},
        true
      )
    );
  }

  public static getJobsBoardPosts(
    jobsBoardSearchFilters: JobsBoardSearchFiltersPayload,
    userId: number
  ): Promise<JobsBoardApplication[]> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/searchJobsBoard`,
        HttpMethod.POST,
        { filters: jobsBoardSearchFilters, user_id: userId }
      )
    );
  }

  public static getJobsBoardLocations(
    searchTerm: string,
    userId: number
  ): Promise<LocationModel[]> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/getJobsBoardLocations`,
        HttpMethod.POST,
        { search_term: searchTerm, user_id: userId }
      )
    );
  }

  public static getJobsBoardLocationsPublic(
    search_term: string,
    public_country: ProductionCountry
  ): Promise<LocationModel[]> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/public/getJobsBoardLocations`,
        HttpMethod.POST,
        { search_term, public_country },
        {},
        {},
        true
      )
    );
  }

  public static getJobsBoardPost(
    applicationUuid: string,
    userId: number
  ): Promise<JobsBoardApplication> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/getJobsBoardApplication/${applicationUuid}?user_id=${userId}`,
        HttpMethod.GET
      )
    );
  }

  public static getJobsBoardPostPublic(
    applicationUuid: string
  ): Promise<JobsBoardApplication> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/applications/public/getJobsBoardApplication/${applicationUuid}`,
        HttpMethod.GET,
        {},
        {},
        {},
        true
      )
    );
  }

  public static getJobsBoardDefaultFilters(
    userId: number
  ): Promise<JobsBoardSearchFiltersPayload> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiApplications,
        `/users/${userId}/jobsBoardDefaultFilters`,
        HttpMethod.GET
      )
    );
  }
}
